import React, { useCallback, useRef, useState } from 'react'
import Button from '../Button'
import Axios from 'axios'
import I18n from 'i18n-js'

interface Props {
  confirmPath: string
  authenticityToken: string
}

const submitToNeo = (
  submitUrl: string,
  authenticityToken: string,
  adult: boolean,
) => {
  return new Promise<void>((resolve, reject) => {
    const data = {
      authenticity_token: authenticityToken,
      adult: adult,
    }

    Axios.post(submitUrl, data).then(({data}) => {
      if (data?.error) {
        reject(data.error)
      } else {
        resolve()
      }
    }).catch((err) => {
        reject(err)
    })
  })
}

const ComfirmAdultSettingPopup: React.FC<Props> = ({ authenticityToken, confirmPath }) => {
  const [ show, setShow ] = useState(true);
  const authRef = useRef(authenticityToken)
  authRef.current = authenticityToken
  const confirmPathRef = useRef(confirmPath)
  confirmPathRef.current = confirmPath

  const setAdult = useCallback((isAdult: boolean) => {
    console.log("set", isAdult);
    submitToNeo(confirmPathRef.current, authRef.current, isAdult)
      .then(() => setShow(false))
      .catch(() => { console.log("could not save adult setting")})
  }, []);

  if (!show) { return null; }

  return <div className="confirmAdultPopup">
    <div className="confirmAdultPopup__inner">
      <div className="confirmAdultPopup__info">
        {I18n.t('confirm_adult_setting.info')}
      </div>
      <div className="confirmAdultPopup__actionArea">
        <Button primary onClick={() => setAdult(false)}>{I18n.t('confirm_adult_setting.action_below18')}</Button>
        <Button primary onClick={() => setAdult(true)}>{I18n.t('confirm_adult_setting.action_18plus')}</Button>
      </div>
    </div>
  </div>
}

export default ComfirmAdultSettingPopup
